import React, { Component } from 'react';
import IconeSobrescrito from './IconeSobrescrito';
import { Report } from '@mui/icons-material';

interface IPropsIconeReportSobrescrito {
}


export default class IconeReportSobrescrito extends React.Component<IPropsIconeReportSobrescrito> {


    render() {
        return (
            <IconeSobrescrito esquerda>
                <Report />
            </IconeSobrescrito>
        );
    }
}
